import React from "react";
import _ from "lodash";
import {Button, Input} from "antd";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";

export default class EditFragment extends React.Component {
    constructor(props) {
        super(props);

        const {defaultValue} = props;
        this.state = {
            value: defaultValue,
        };
    }

    render() {
        const {onCommit, onCancel} = this.props;
        const {value} = this.state;

        return (
            <>
                <Input value={value} onChange={e => this.setState({value: e.target.value})} autoFocus />
                <Button disabled={_.isEmpty(value)} onClick={() => onCommit(value)} type="primary" style={{height: 32, marginLeft: 6}}>
                    <CheckOutlined />
                </Button>
                <Button onClick={onCancel} type="primary" style={{height: 32, margin: "0 12px 0 6px"}}>
                    <CloseOutlined />
                </Button>
            </>
        );
    }
}
